import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMinusComponent } from "./med-icon-minus.component";

@NgModule({
  declarations: [
    MedIconMinusComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMinusComponent,
  ],
})
export class MedIconMinusModule { }
